import { useTranslation } from 'react-i18next';

import { Icon, Status } from '@wf/components';

import { ArrayFields, FeeFields } from '../../../../License/types/fieldEnums';

import useComparisonValues from '../../../hooks/useComparisonValues';

interface IStatusCellProps {
  id: number;
  value: string | null;
}

function StatusCell({ id, value }: IStatusCellProps) {
  const { t } = useTranslation();
  const path = `/${ArrayFields.fees}/${id}/${FeeFields.receiptNumber}`;

  const { oldValue, newValue } = useComparisonValues({ path, value });

  if (!newValue || oldValue === newValue) {
    return <Status color={newValue ? 'success' : 'typography'}>{newValue ? t('Paid') : t('Unpaid')}</Status>;
  }

  return (
    <div className="flex content-end">
      <Status color="typography">{t('Unpaid')}</Status>
      <Icon name="ic_sorting_left" size={24} />
      <Status color="success">{t('Paid')}</Status>
    </div>
  );
}

export default StatusCell;
